import { ListRendererFn } from "./ListRenderer";
import styles from "../styles.module.scss";
import HeroView from "../componentView/HeroView";
import React from "react";
import { useSelector } from "react-redux";
import { State } from "core/index";

const HeroRenderer: ListRendererFn = ({ list, leaveFor, page }) => {
  const { config } = useSelector((state: State) => state.globalState);
  const withDynamicPricing = !config?.features?.noDynamicPricing;
  const hasGamePassHero = list.tiles[0].gamePass;

  if (withDynamicPricing && hasGamePassHero) {
    return null;
  }

  return (
    <HeroView
      list={list}
      leaveFor={leaveFor}
      key={list.uuid}
      className={styles.hero}
      page={page}
    />
  );
};
export { HeroRenderer };
